<template>
  <div class="col-12 base-input">
    <input
      ref="baseInput"
      v-model="textVal"
      :class="[isInvalid ? 'isInvalid' : '', 'baseinput']"
      :placeholder="placeHolder"
      :type="inputType"
      @keyup.enter="$emit('enter', $event)"
      v-on:input="updateValue($event.target.value)"
      :disabled="disabled"
    />
    <div v-if="isInvalid" class="error-text-container">
      <span class="error-text paragraph12">{{$t(errorText)}}</span>
    </div>
    <span v-if="isPassword">
      <font-awesome-icon
          :icon="passwordIcon"
          class="password-visibility"
          @click="togglePasswordVisibility"
        />
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    text: {
      type: String,
      required: false,
    },
    backgroundColor: {
      type: String,
      default: 'rgba(53, 54, 61, 0.035)',
    },
    placeholderColor: {
      type: String,
      required: false,
    },
    isInvalid: {
      type: Boolean,
      required: false,
    },
    errorText: {
      type: String,
      required: false,
    },
    textColor: {
      type: String,
      required: false,
    },
    placeHolder: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      textVal: '',
      isPasswordVisible: false,
    };
  },
  mounted() {
    this.textVal = this.text;
    this.$refs.baseInput.style.backgroundColor = this.backgroundColor;
    this.$refs.baseInput.style.color = this.textColor;
  },
  computed: {
    isPassword() {
      return this.type === 'password';
    },
    passwordIcon() {
      return this.isPasswordVisible ? 'eye-slash' : 'eye';
    },
    inputType() {
      if (this.isPassword && this.isPasswordVisible) {
        return 'text';
      }
      return this.type;
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('baseInputValue', value);
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
  watch: {
    text(newVal) {
      this.textVal = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.base-input {
  .error-text-container {
    text-align: left;
    .error-text {
      color: $secondary-color !important;
      font-size: 10px;
    }
  }
  .isInvalid {
    transition: border 1s;
    border: 2px solid $secondary-color;
  }
  input {
    background-color: rgba(53, 54, 61, 0.35);
    transition: outline 1s;
    width: 100%;
    height: 40px;
    padding: 0 0 0 12px;
    border-radius: 8px;
    line-height: 40px;
    border: 0;
    &:focus {
      outline: none;
    }
  }
  .password-visibility {
    opacity: 0.4;
    cursor: pointer;
    position: absolute;
    right: 23px;
    top: 20px;
    transform: translateY(-50%);
  }
}
</style>
